import type { Schema } from '@wix/wix-data-schema-types'
import {
  isCatalogCollectionSchema,
  isCategoryCollection,
} from '../collections/collectionTypes'

export type CollectionType = 'category' | 'catalog' | 'cms'

export const getCollectionType = (collection: Schema): CollectionType => {
  if (isCategoryCollection(collection)) {
    return 'category'
  }
  if (isCatalogCollectionSchema(collection)) {
    return 'catalog'
  }
  return 'cms'
}
